export default "assets/images/icons/twitter-x-59d3021f.svg";